module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "admin"
  }, [_c('Loader', {
    attrs: {
      "loading": _vm.loader,
      "fixed": true
    }
  }), _vm._v(" "), (_vm.zone) ? _c('p', {
    staticClass: "admin-user-title"
  }, [_vm._v("\n        " + _vm._s(_vm.zone.name) + " " + _vm._s(_vm.currentBrandZone && _vm.currentBrandZone.zoneGroupsRights ? "(" + _vm.currentBrandZone.zoneGroupsRights.name + ")" : "") + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.zone && _vm.currentBrandZone) ? _c('div', {
    staticClass: "admin-user"
  }, [_c('div', {
    staticClass: "admin-user-infos table-responsive"
  }, [_c('table', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t("zonerole.ref")) + " :")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.zone.refClient ? _vm.zone.refClient : "-"))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t("zonerole.type")) + " :")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currentBrandZone.zoneRelationType ? _vm.currentBrandZone.zoneRelationType.name : "-"))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t("zonerole.group")) + ":")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currentBrandZone.zoneGroupsRights ? _vm.currentBrandZone.zoneGroupsRights.name : "-"))])])])]), _vm._v(" "), (_vm.canManageZone()) ? _c('div', {
    staticClass: "row d-flex align-items-center mt-5"
  }, [_c('div', {
    staticClass: "col-12 col-sm-auto admin-user-manage"
  }, [_c('span', {}, [_vm._v(_vm._s(_vm.$t("userAdmin.manage")) + " :")])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-sm"
  }, [_c('ClientColorButton', {
    staticClass: "mr-4",
    attrs: {
      "size": "l",
      "inactive-color": true
    },
    on: {
      "click": function($event) {
        _vm.openModalEditZone();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("userAdmin.edit_info")))]), _vm._v(" "), _c('ClientColorButton', {
    staticClass: "mr-4",
    attrs: {
      "size": "l",
      "inactive-color": true
    },
    on: {
      "click": function($event) {
        _vm.openModalDisableBrandZone();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("userAdmin.delete_from_brand")))]), _vm._v(" "), (_vm.isSuperAdmin()) ? _c('ClientColorButton', {
    staticClass: "mr-4",
    attrs: {
      "size": "l",
      "inactive-color": true
    },
    on: {
      "click": function($event) {
        _vm.openModalDisableZone();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("zonerole.disable_zone")))]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.brandZonesFiltered.length) ? _c('div', {
    staticClass: "row mt-5"
  }, [_c('div', {
    staticClass: "col-12 col-md-auto pb-3 admin-user-access"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("userAdmin.access")) + " :")])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-md"
  }, [_c('div', {
    staticClass: "row d-flex flex-row justify-content-center justify-content-sm-start"
  }, _vm._l((_vm.brandZonesFiltered), function(brandZone, key) {
    return (_vm.isSuperAdmin() || _vm.isClientAdmin(brandZone.brand.id)) ? _c('div', {
      key: key,
      staticClass: "px-4 pb-3",
      staticStyle: {
        "flex-basis": "250px",
        "flex-grow": "0"
      }
    }, [_c('ClientColorButton', {
      attrs: {
        "background-color": "#727a96",
        "width": "100%"
      },
      on: {
        "click": function($event) {
          _vm.changeBrand(brandZone.brand);
        }
      }
    }, [_vm._v("\n                            " + _vm._s(brandZone.brand.name) + "\n                        ")])], 1) : _vm._e()
  }))]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-md d-flex justify-content-end align-self-end"
  }, [_c('History', {
    attrs: {
      "object": _vm.zone,
      "object-type": _vm.OBJECT_TYPE.ZONES,
      "is-dark": false,
      "is-grey": true
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.modalParamsEditZone) ? _c('EditZone', {
    attrs: {
      "params": _vm.modalParamsEditZone
    },
    on: {
      "success": function($event) {
        _vm.loadZone();
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.modalParamsDisableBrandZone) ? _c('DisableBrandZone', {
    attrs: {
      "params": _vm.modalParamsDisableBrandZone
    },
    on: {
      "success": function($event) {
        _vm.close();
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.modalParamsDisableZone) ? _c('DisableZone', {
    attrs: {
      "params": _vm.modalParamsDisableZone
    },
    on: {
      "success": function($event) {
        _vm.close();
      }
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.getBrandAccess && _vm.getBrandAccess.length) ? _c('div', {
    staticClass: "admin-role mt-5"
  }, [_c('div', {
    staticClass: "row mb-4"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('span', {
    staticClass: "admin-role-title"
  }, [_vm._v(_vm._s(_vm.$t("userrole.rights")) + " :")])]), _vm._v(" "), _c('div', {
    staticClass: "col-auto"
  }, [(_vm.zoneUsersFiltered.length) ? _c('ClientColorButton', {
    attrs: {
      "color": _vm.currentBrand.colorLinks
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v(_vm._s(_vm.$t("common.save")))]) : _vm._e()], 1)]), _vm._v(" "), _c('b-tabs', {
    attrs: {
      "content-class": "mt-3"
    }
  }, [_vm._l((_vm.brandAccessFiltered), function(brandAccess, key) {
    return (_vm.displayTab(brandAccess.application)) ? _c('b-tab', {
      key: key,
      attrs: {
        "title": _vm.getTranslate(brandAccess.terms.name),
        "active": _vm.rightsUserTab ? key === parseInt(_vm.rightsUserTab, 10) : key === 0
      },
      on: {
        "click": function($event) {
          _vm.changeApp(brandAccess, key);
        }
      }
    }, [_c('div', {
      staticClass: "row mt-4"
    }, [_c('div', {
      staticClass: "col"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.search),
        expression: "search"
      }],
      staticClass: "rem3rch-input-text",
      attrs: {
        "type": "text",
        "id": "searchBySearch"
      },
      domProps: {
        "value": (_vm.search)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.search = $event.target.value
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "m-0 pointer ml-3",
      attrs: {
        "for": "searchBySearch"
      }
    }, [_c('i', {
      staticClass: "fa fa-search fa-lg color-grey"
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "responsive-table-old"
    }, [_c('table', {
      staticClass: "admin-role-table"
    }, [_c('thead', [_c('tr', [_c('th', {
      attrs: {
        "colspan": "4"
      }
    }, [_c('div', {
      staticClass: "row d-flex align-items-center"
    }, [_c('div', {
      staticClass: "col-auto"
    }, [_c('ClientColorButton', {
      staticClass: "mt-4",
      attrs: {
        "inactive-color": true
      },
      on: {
        "click": function($event) {
          _vm.selectAll();
        }
      }
    }, [_vm._v(_vm._s(_vm.$t("common.selectAll")))])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-auto"
    }, [_c('ClientColorButton', {
      staticClass: "mt-4",
      attrs: {
        "inactive-color": true
      },
      on: {
        "click": function($event) {
          _vm.selectNone();
        }
      }
    }, [_vm._v(_vm._s(_vm.$t("common.selectNone")))])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-auto"
    }, [_c('ClientColorButton', {
      staticClass: "mt-4",
      attrs: {
        "inactive-color": true
      },
      on: {
        "click": function($event) {
          _vm.resetSelectedProfiles();
        }
      }
    }, [_vm._v(_vm._s(_vm.$t("common.resetSelection")))])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-auto admin-role-filter mt-4"
    }, [_c('Multiselect', {
      attrs: {
        "options": _vm.profiles,
        "label": 'name',
        "track-by": "name",
        "multiple": false,
        "select-label": '',
        "searchable": false,
        "close-on-select": true,
        "show-labels": true,
        "placeholder": _vm.$t('zonerole.filterProfile'),
        "deselect-label": _vm.$t('common.delete')
      },
      model: {
        value: (_vm.filteredProfile),
        callback: function($$v) {
          _vm.filteredProfile = $$v
        },
        expression: "filteredProfile"
      }
    })], 1)])]), _vm._v(" "), _c('th', {
      staticClass: "header-profile admin-role-filter mt-4"
    }, [(_vm.checkedUsers.length > 0) ? _c('Multiselect', {
      attrs: {
        "options": _vm.profilesFiltered,
        "label": 'name',
        "track-by": "name",
        "multiple": false,
        "select-label": '',
        "searchable": false,
        "close-on-select": true,
        "show-labels": true,
        "placeholder": _vm.$t('zonerole.selectProfile'),
        "deselect-label": _vm.$t('common.delete')
      },
      on: {
        "input": function($event) {
          _vm.updateCheckedUsersProfile(_vm.multiProfileUpdate);
        }
      },
      model: {
        value: (_vm.multiProfileUpdate),
        callback: function($$v) {
          _vm.multiProfileUpdate = $$v
        },
        expression: "multiProfileUpdate"
      }
    }) : _vm._e()], 1)])]), _vm._v(" "), _c('tbody', _vm._l((_vm.zoneUsersFiltered), function(user, key) {
      return _c('tr', {
        key: key
      }, [_c('td', {
        staticClass: "color",
        style: ({
          backgroundColor: _vm.getProfileColor(user.id)
        })
      }), _vm._v(" "), _c('td', {
        staticClass: "checkbox"
      }, [(_vm.profileCanBeUpdated(_vm.seletedProfileByUser[user.id])) ? [_c('label', {
        staticClass: "label-checkbox pointer mb-0 d-flex align-items-center justify-content-center",
        attrs: {
          "for": 'checkbox_user_' + user.id
        }
      }, [_c('span', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.checkedUsers.includes(user.id)),
          expression: "checkedUsers.includes(user.id)"
        }],
        staticClass: "rem3rch-checkbox rem3rch-checkbox",
        on: {
          "click": function($event) {
            _vm.checkUser(user.id, false);
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-check"
      })]), _vm._v(" "), (!_vm.checkedUsers.includes(user.id)) ? _c('span', {
        staticClass: "rem3rch-checkbox rem3rch-checkbox",
        on: {
          "click": function($event) {
            _vm.checkUser(user.id, true);
          }
        }
      }) : _vm._e()])] : _vm._e()], 2), _vm._v(" "), _c('td', {
        staticClass: "id"
      }, [_c('span', [_vm._v(_vm._s(user.id))])]), _vm._v(" "), _c('td', {
        staticClass: "name"
      }, [_c('span', [_vm._v(_vm._s(user.firstname.toLowerCase() + " "))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(user.lastname.toLowerCase()))])]), _vm._v(" "), _c('td', {
        staticClass: "profile"
      }, [_c('Multiselect', {
        attrs: {
          "options": _vm.profilesFiltered,
          "label": 'name',
          "track-by": "name",
          "multiple": false,
          "select-label": '',
          "searchable": false,
          "close-on-select": true,
          "show-labels": true,
          "placeholder": _vm.$t('userrole.selectProfile'),
          "deselect-label": _vm.$t('common.delete'),
          "disabled": !_vm.profileCanBeUpdated(_vm.seletedProfileByUser[user.id])
        },
        model: {
          value: (_vm.seletedProfileByUser[user.id]),
          callback: function($$v) {
            _vm.$set(_vm.seletedProfileByUser, user.id, $$v)
          },
          expression: "seletedProfileByUser[user.id]"
        }
      })], 1), _vm._v(" "), _c('td', {
        staticClass: "view-zone text-center"
      }, [_c('ClientColorButton', {
        attrs: {
          "inactive-color": true
        },
        on: {
          "click": function($event) {
            _vm.$router.push({
              path: '/users/user/' + user.id
            });
          }
        }
      }, [_vm._v(_vm._s(_vm.$t("zonerole.viewUser")))])], 1)])
    }))]), _vm._v(" "), (!_vm.zoneUsersFiltered.length) ? _c('div', {
      staticClass: "d-flex align-items-center justify-content-center notfound"
    }, [_c('span', [_vm._v(_vm._s(_vm.$t("userrole.notfound")))])]) : _vm._e()])]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-center mt-4"
  }, [_c('ClientColorButton', {
    staticClass: "mr-3",
    attrs: {
      "inactive-color": true
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v(_vm._s(_vm.$t("common.cancel")))]), _vm._v(" "), (_vm.zoneUsersFiltered.length) ? _c('ClientColorButton', {
    attrs: {
      "color": _vm.currentBrand.colorLinks
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v(_vm._s(_vm.$t("common.save")))]) : _vm._e()], 1)], 2)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-872bf72a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/zone/ZoneRole.vue
// module id = 3303
// module chunks = 0